import * as React from "react";

function SvgRounded1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="rounded-1_svg__st1" d="M1602.9 209l-9.3-117.7c-3.8-48.1-46.3-84.4-94.4-80.6L-8 131.2V209h1610.9z" /></svg>;
}

export default SvgRounded1;